import { Component, OnInit, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    imports: [RouterLink]
})
export class FooterComponent implements OnInit {

  isMobile = false;

  ngOnInit() {
    if (window.innerWidth <= 749) {
      this.isMobile = true;
    }
  }

  @HostListener("window:resize", [])
  onResize() {
    const width = window.innerWidth;
    this.isMobile = width <= 749;
  }
}
